import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { Show } from '@side/pantry';
import { useState } from 'react';
import type {
  ReferralAgent,
  ReferralTypeValue,
} from '@/common/hooks/referrals/types';
import { ContactChangeAlert } from '@/components/ContactChangeAlert/ContactChangeAlert';
import { ContactChangeDialog } from '@/components/ContactChangeDialog/ContactChangeDialog';
import { useReferralAgentSync } from './useReferralAgentSync';

type AgentSyncBannerProps = {
  referringAgent: Partial<ReferralAgent>;
  transactingAgent: Partial<ReferralAgent>;
  referralType: ReferralTypeValue;
  referralId: string;
  sx?: SystemStyleObject<Theme>;
};

export function AgentSyncBanner({
  referringAgent,
  transactingAgent,
  referralType,
  referralId,
  sx,
}: AgentSyncBannerProps) {
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const [ignoreAlert, setIgnoreAlert] = useState(false);
  const { changedRecords, syncContacts } = useReferralAgentSync({
    referringAgent,
    transactingAgent,
    referralType,
    referralId,
  });

  return (
    <>
      <Show when={!ignoreAlert && changedRecords.length > 0}>
        <ContactChangeAlert
          onIgnore={() => setIgnoreAlert(true)}
          onReviewAndUpdate={() => setSyncDialogOpen(true)}
          sx={sx}
          title={
            changedRecords.length === 1
              ? `Outdated Data on ${changedRecords[0].label}`
              : 'Outdated Data on Multiple Contacts'
          }
        />
      </Show>
      <ContactChangeDialog
        contacts={changedRecords}
        onSubmit={syncContacts}
        title="Review Agent Contact Updates"
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
      />
    </>
  );
}
